import { useState, useEffect } from 'react'

import SearchBar from 'components/Search/SearchBar'
import ContentFrame from 'components/Frame/ContentFrame'
import BrandColorButton from 'components/Buttons/BrandColorButton'
import AthleteProfileListItem from 'components/Athlete/AthleteProfileListItem'

export default function GroupAthletesTabViewMode({ 
    coaches=[],
    groupAthletes=[],
    setViewMode = () => {}
}) {

    const [searchTerm, setSearchTerm] = useState('')
    const [filteredGroupAthletes, setFilteredGroupAthletes] = useState([])

    const FilterAthletesBySearchTerm = (item) => {
        const fullName = item.firstName.toLowerCase() + ' ' + item.lastName.toLowerCase()

        return (
            fullName.includes(searchTerm.toLowerCase()) ||
            item.email.toLowerCase().includes(searchTerm.toLowerCase())
        )
    }

    useEffect(() => {
        if (groupAthletes !== null) {
            const filtered = groupAthletes.filter(item => FilterAthletesBySearchTerm(item))
            setFilteredGroupAthletes(filtered)
        }
    }, [groupAthletes, searchTerm])

    if (coaches === null || groupAthletes === null) {
        return (
            <div className='space-y-4'>
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
            </div>
        )
    }

    return (
        <div className="h-full flex flex-col min-h-0 gap-y-4">
            <div className="flex-shrink-0 flex items-center gap-x-4">
                <div className="flex-grow">                        
                    <SearchBar 
                        placeholder="Enter Athlete Name or Email"
                        searchTerm={searchTerm} 
                        setSearchTerm={setSearchTerm} 
                        showFiltersToggle={false}
                    />
                </div>

                <div className="w-32">
                    <BrandColorButton
                        size="small"
                        text="Manage"
                        action={() => setViewMode('edit-group-athletes')}
                        className="shadow-md"
                    />
                </div>
            </div>

            <ContentFrame className='flex-1 min-h-0 !items-stretch !justify-start'>
                <div className='w-full h-full divide-y divide-gray-200 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                    {filteredGroupAthletes.length === 0 &&
                        <div className="text-center text-gray-500 py-4">No athletes found</div>
                    }

                    {filteredGroupAthletes.length > 0 && filteredGroupAthletes.map((athlete, index) => (
                        <AthleteProfileListItem key={index} athlete={athlete} coaches={coaches} displayCoach={false} openProfileInNewTab={true} />
                    ))}
                </div>
            </ContentFrame>
        </div>
    )
}